import { Box, Switch, Typography, withStyles } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { setAssistStatus, updateAssistStatus } from '@root-gipro/modules/userProjects/store/actions'
import { IState } from '@root-gipro/store/interfaces'
import React, { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

// Константы для стилей
const SWITCH_STYLES = {
	COLORS: {
		ACTIVE: '#1baaf0',
		INACTIVE: '#ccc',
		THUMB: '#fff',
	},
	SIZES: {
		WIDTH: 42,
		HEIGHT: 23,
		THUMB: {
			WIDTH: 20,
			HEIGHT: 20,
		},
	},
	SPACING: {
		TOP: 3,
		LEFT: 2,
	},
} as const

// Интерфейсы
interface IAssistantToggleProps {
	handleOffAssist: () => void
}

// Стили компонента
const useStyles = makeStyles(() => ({
	container: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		padding: '8px 0 10px',
		backgroundColor: '#ffffff',
	},
	text: {
		fontSize: '16px',
		flexGrow: 1,
	},
}))

// Кастомный переключатель
const CustomSwitch = withStyles({
	switchBase: {
		top: SWITCH_STYLES.SPACING.TOP,
		left: SWITCH_STYLES.SPACING.LEFT,
		color: SWITCH_STYLES.COLORS.THUMB,
		'&$checked': {
			color: SWITCH_STYLES.COLORS.THUMB,
		},
		'&$checked + $track': {
			backgroundColor: SWITCH_STYLES.COLORS.ACTIVE,
			opacity: 1,
		},
	},
	checked: {},
	track: {
		borderRadius: SWITCH_STYLES.SIZES.HEIGHT / 2,
		backgroundColor: SWITCH_STYLES.COLORS.INACTIVE,
		opacity: 1,
	},
	thumb: {
		width: SWITCH_STYLES.SIZES.THUMB.WIDTH,
		height: SWITCH_STYLES.SIZES.THUMB.HEIGHT,
	},
	root: {
		width: SWITCH_STYLES.SIZES.WIDTH,
		height: SWITCH_STYLES.SIZES.HEIGHT,
		padding: 0,
	},
})(Switch)

const AssistantToggle: React.FC<IAssistantToggleProps> = ({ handleOffAssist }) => {
	const classes = useStyles()
	const { enableUncAssist } = useSelector((state: IState) => state.userProjects)
	const dispatch = useDispatch()

	const [checked, setChecked] = React.useState(enableUncAssist)

	const handleToggle = useCallback(() => {
		setChecked(prev => {
			const newValue = !prev
			dispatch(updateAssistStatus(newValue ? '1' : '0'))
			dispatch(setAssistStatus(newValue))

			// Вызываем handleOffAssist только при выключении ассистента
			if (!newValue) {
				handleOffAssist()
			}

			return newValue
		})
	}, [dispatch, handleOffAssist])

	useEffect(() => {
		setChecked(enableUncAssist)
	}, [enableUncAssist])

	return (
		<Box className={classes.container}>
			<Typography className={classes.text}>Ассистент работы с УНЦ</Typography>
			{<CustomSwitch checked={checked} onChange={handleToggle} color='primary' />}
		</Box>
	)
}

export default AssistantToggle
